import { AppSettings } from "@/AppSettings";
import useItem from "@/hooks/form/source-data/useItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LoadingButton } from "@mui/lab";
import { Box, Tooltip, TooltipProps, styled } from "@mui/material";
import { FC } from "react";
import { Link } from "react-router-dom";
import { ButtonPlaceholder, CounterButton, CounterButtonBox, StyledTooltip } from ".";



const SourceDataFormNoteButton: FC<{ itemData?: ReturnType<typeof useItem>; createButtonProps: (link: string) => any }> = ({
    itemData,
    createButtonProps
}) => {
    if (!itemData) {
        return <ButtonPlaceholder />;
    }

    const disabled = !itemData.sourceDataItem;

    let buttonProps: any = createButtonProps(itemData?.preview ? itemData.previewAuditLink : itemData?.dataAuditLink!);

    return (
        <Box>
            <StyledTooltip
                title={
                    disabled ? 
                        'Entry missing from OpenClinica':
                        'Audit'
                }
                followCursor
            >
                <CounterButtonBox>
                    <CounterButton
                        variant="outlined"
                        //@ts-ignore
                        {...buttonProps}
                        disabled={disabled}
                    >
                        <FontAwesomeIcon icon={AppSettings.icons.audit} size="2x" />
                    </CounterButton>
                </CounterButtonBox>
            </StyledTooltip>
        </Box>
    );
};

export default SourceDataFormNoteButton;